import { Col, Row, Table } from "reactstrap";
import PropTypes from "prop-types";
import styled from "styled-components";
import { map } from "lodash";
import React, { useMemo } from "react";
import ReactTableForm from "../../../../../components/Common/ReactTableForm";

const InvoiceTemplate2 = ({
  classification,
  table_data,
  notCustomColls,
  ClientColls,
  valuesTemplate,
  handleChangeTable,
  total_in_custom_currency,
  base64Image,
  invoiceData,
  langUA,
  with_signature,
  grandTotalWithTax,
  demo
}) => {

  const t = ['type', 'period', 'amount'];

  const notCusColls = useMemo(() => {
    notCustomColls.map((i, k) => {
      return {
        ...i,
        Header: demo ? `${valuesTemplate?.[t[k]] || i.Header}` : i.Header,
      }
    })
  })

  const ClColls = useMemo(() => {
    return ClientColls.map((i, k) => {
      return {
        ...i,
        Header: demo ? `${valuesTemplate?.[t[k]] || i.Header}` : i.Header,
      }
    })
  })

  return (
    <React.Fragment>
      <Row>
        <Col xs={12}>
          <h4 className="font-size-24 text-center" style={{ color: "#000", fontWeight: 400 }}>
            {demo ? `${valuesTemplate?.invoice || 'Invoice'}` : langUA ? 'Рахунок' : 'Invoice'} №{invoiceData.number}
          </h4>
          <address className="text-end" style={{ paddingRight: 20 }}>
            {demo ? `${valuesTemplate?.date || 'DATE'}` : langUA ? 'Дата' : 'DATE'}: {invoiceData.date_issue}
          </address>
          {/* <address>{invoiceData.supplier_street}</address> */}
        </Col>
        <Col xs={6}>
          <address>
            <br />
            {/* {invoiceData.bank_name} */}
            {langUA ? invoiceData.supplier_signer : invoiceData.supplier_name}
            <br />
            {invoiceData.bank_name}
            {/* {invoiceData.bank_street} Bank address */}
            <br />
            {invoiceData.bank_account_number}{" "}
            {invoiceData?.bank_swift_bic && (
              <>
                <br />
                {invoiceData?.bank_swift_bic}
              </>
            )}
            {/* Account № */}
            <br />
            {invoiceData?.bank_edrpou && `${langUA ? 'ЄДРПОУ' : 'EDRPOU'} ${invoiceData.bank_edrpou}`}
          </address>
        </Col>
        <Col xs={6}>
          <address className="text-start">
            <strong>{demo ? `${valuesTemplate?.to || 'TO'}` : langUA ? 'Платник' : 'TO'}: </strong> <br />
            <span>{invoiceData.customer_name}</span>
            {/* <br /> */}
            {/* <span>{invoiceData.customer_street}</span> */}
          </address>
        </Col>

      </Row>
      <div style={{ paddingBottom: 80 }} />
      <Row className="mt-3">
        {invoiceData && (
          <ReactTableForm
            columns={
              classification !== 'CUSTOM' && classification !== 'USER'
                ? demo && !with_signature ? notCusColls : notCustomColls
                : demo && !with_signature ? ClColls : ClientColls
            }
            // data={{
            //   results:
            //     classification !== 'CUSTOM' && classification !== 'USER'
            //       ? table_data //SalaryTable()
            //       : invoiceData?.items,
            // }}
            data={{
              results:
                classification !== 'CUSTOM' && classification !== 'USER' ? table_data : invoiceData?.items.map((i) => {
                  console.log(i)
                  return {
                    ...i,
                    custom_unit_price: langUA ? i.custom_unit_price.split(" ")[0] + " ГРН" : i.custom_unit_price,
                    date_from: invoiceData.date_from,
                    date_to: invoiceData.date_to
                  }
                }),
            }}
            onTableChange={handleChangeTable}
          />
        )}
        {invoiceData.show_tax && invoiceData?.tax_type && (
          <h6 className="m-0 text-end">
            {invoiceData.tax_type}: {invoiceData.tax_rate}%
          </h6>
        )}
        <h4 className="m-0 text-end">
          {demo ? `${valuesTemplate?.grand_total || `Grand total`}: ` : langUA ? (
            <>
              До сплати:{" "}
              {invoiceData.show_tax ? grandTotalWithTax(
                invoiceData.total_in_the_selected_currency,
                invoiceData.tax_rate
              ) : invoiceData.total_in_the_selected_currency}
              {" "}
              {total_in_custom_currency?.split(" ")[1]}
            </>
          ) : (
            <>
              Grand total:{" "}
              {invoiceData.show_tax ? grandTotalWithTax(
                invoiceData.total_in_the_selected_currency,
                invoiceData.tax_rate
              ) : invoiceData.total_in_the_selected_currency}
              {" "}
              {total_in_custom_currency?.split(" ")[1]}
            </>
          )}
        </h4>
      </Row>
      <div className="py-2 mt-3"></div>
      <div style={{ paddingBottom: 80 }} />
      <StyledRow
        id="signature__preview_invoice"
        className="row align-items-center"
      >
        <Col
          xl={4}
          className="text-start d-flex align-items-center"
        >
          <h5 className="ml-5">
            <span>
              {demo ? `${valuesTemplate?.director || `Director`}` : langUA ? 'Директор' : 'Director'}
            </span>{" "}
            {invoiceData.supplier_signer}
          </h5>
        </Col>
        <Col
          xl={4}
          style={{ height: 110 }}
          className="d-flex justify-content-center align-items-center"
        >
          {demo && !with_signature ? langUA ? 'Підпис' : 'Signature' : (<img
            id="signature__preview_image"
            src={base64Image || ""}
            alt="signature__preview_image"
          />)}
        </Col>
        <Col xl={4} className="align-items-center"></Col>
      </StyledRow>
    </React.Fragment>
  );
};

const StyledRow = styled.div`
  margin-bottom: 20px;

  img {
    width: auto;
    height: 110px;
  }

  h4 {
    margin-left: 15px;
    margin-bottom: 0;
  }
`;

InvoiceTemplate2.propTypes = {
  classification: PropTypes.any,
  table_data: PropTypes.object,
  notCustomColls: PropTypes.any,
  ClientColls: PropTypes.any,
  handleChangeTable: PropTypes.func,
  total_in_custom_currency: PropTypes.any,
  base64Image: PropTypes.any,
  invoiceData: PropTypes.object.isRequired,
  langUA: PropTypes.boolean,
  valuesTemplate: PropTypes.any,
  with_signature: PropTypes.bool,
  demo: PropTypes.boolean,
  grandTotalWithTax: PropTypes.func,
};

export default InvoiceTemplate2;
